<template>
  <div class="link-views white-bg">
    <div class="top">
      <Button type="primary" @click="addItemFn('editItem')">添加</Button>
    </div>
    <div class="select-div">
      <div class="mr">
        <span>时间选择：</span>
        <DatePicker
          v-model="daterange"
          format="yyyy-MM-dd"
          type="daterange"
          placement="bottom-start"
          placeholder="时间选择"
          style="width: auto"
          clearable
          :editable="false"
          @on-change="(val)=>getTime(val,'daterange')"
        ></DatePicker>
      </div>
      <div>
        <Button type="primary" class="mr" icon="md-search" @click="searchByTime('search')">查询</Button>
        <Button type="primary" icon="md-refresh" @click="searchByTime('refresh')">重置</Button>
      </div>
    </div>
    <div class="table-div">
      <!-- 表格 -->
      <Table :columns="columns" :data="listObj.Result" :loading="loading">
        <template slot-scope="{ row }" slot="ClassIdList">
          <div v-if="row.ClassId.length>0" class="p4">
            <div v-for="(item,index) in row.ClassName.split('、')" :key="index" class="p4">{{item}}</div>
          </div>
          <div v-else>暂无教学班级</div>
        </template>
        <template slot-scope="{ row}" slot="action">
          <div class="action-table">
            <a @click="editItemFn(row)">编辑</a>
            <a @click="delItemFn(row)">删除</a>
          </div>
        </template>
      </Table>
      <!-- 分页 -->
      <div class="page-div">
        <Page
          show-total
          :total="listObj.records"
          :current="pageData.page"
          :page-size="pageData.size"
          @on-change="changePage"
        />
      </div>
    </div>
    <!-- 编辑模态框 -->
    <Modal v-model="showModal" :mask-closable="false" title="设置">
      <Form ref="editItem" :model="editItem" :label-width="135" :rules="ruleValidate">
        <FormItem label="课程名称" prop="CourseName">
          <Input clearable v-model="editItem.CourseName"/>
        </FormItem>
         <FormItem label="相关实验" prop="ExpID">
          <i-select v-model="editItem.ExpID">
              <i-option
                v-for="item in ExperimentList"
                :value="item.ExpID"
                :key="item.ExpID"
              >{{ item.ExpName }}</i-option>
            </i-select>
        </FormItem>
        <FormItem label="教学要求" prop="Counts">
          <InputNumber :min="1" v-model="editItem.Counts" style="width:50%"></InputNumber>
          <span style="color:red">&nbsp;&nbsp;&nbsp;(要求学生练习次数)</span>
        </FormItem>
        <FormItem label="教学班级" prop="ClassId">
          <i-select v-model="editItem.ClassId" multiple>
            <i-option
              v-for="item in classList"
              :value="item.ClassId"
              :key="item.ClassId"
            >{{ item.ClassName }}</i-option>
          </i-select>
        </FormItem>
        <FormItem label="练习时间">
          <DatePicker
            v-model="training"
            split-panels
            type="daterange"
            format="yyyy-MM-dd"
            placement="bottom-end"
            placeholder="练习时间"
            style="width:100%"
            clearable
            :editable="false"
            :options="options1"
            @on-change="(val)=>getTime(val,'training')"
          ></DatePicker>
        </FormItem>
        <FormItem label="考核时间">
          <DatePicker
            v-model="assess"
            split-panels
            type="daterange"
            format="yyyy-MM-dd"
            placement="bottom-end"
            placeholder="考核时间"
            style="width:100%"
            clearable
            :editable="false"
            :options="options2"
            @on-change="(val)=>getTime(val,'assess')"
          ></DatePicker>
        </FormItem>
        <FormItem label="实验成绩占比">
          <InputNumber
            :max="100"
            :min="0"
            v-model="editItem.ResultsPer"
            :formatter="value => `${value}%`"
            :parser="value => value.replace('%', '')"
            style="width:50%"
            @on-change="changeResultsPer"
          ></InputNumber>
        </FormItem>
        <FormItem label="实验报告成绩占比">
          <InputNumber
            :max="100"
            :min="0"
            v-model="editItem.ExpPer"
            :formatter="value => `${value}%`"
            :parser="value => value.replace('%', '')"
            style="width:50%"
            @on-change="changeExpPer"
          ></InputNumber>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="showModal=false">取消</Button>
        <Button type="primary" @click="sureEdit('editItem')">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import * as homeConst from "../../../apiconfig/index.js";
import * as homeApi from "../../../api/teacher-api.js";
export default {
  name: "courseList",
  data() {
    return {
      loading: true,
      daterange: "", //时间段查询
      pageData: {
        start_date: "",
        end_date: "",
        page: 1,
        size: 10
      },
      listObj: {},
      showModal: false,
      editApi: "",
      editItem: { Counts: 0 },
      training: [], //练习时间
      assess: [], //考核时间
      classList: [], //班级数组
      options1: {
        disabledDate(date) {
          return date && date.valueOf() < Date.now() - 86400000;
        }
      },
      options2: {
        disabledDate(date) {
          return date && date.valueOf() < Date.now() - 86400000;
        }
      },
      columns: [
        //设置表格参数
        { title: "教学实验", key: "CourseName", align: "center" },
        { title: "开始时间", key: "StartTime", align: "center" },
        { title: "结束时间", key: "EndTime", align: "center" },
        { title: "教学班级", slot: "ClassIdList", align: "center" },
        { title: "可选操作", slot: "action", align: "center" }
      ],
      ExperimentList:[],//所有实验
      ruleValidate: {
        CourseName: [
          { required: true, message: "教学实验不能为空", trigger: "blur" }
        ],
        ExpID:[ {
            required: true,
             type: "number",
            message: "选择实验",
            trigger: "change"
          }],
        ClassId: [
          {
            required: true,
            type: "array",
            min: 1,
            message: "至少选择一个班级",
            trigger: "change"
          }
        ],
        Counts: [
          {
            required: true,
            type: "number",
            message: "学生练习次数不能为空",
            trigger: "blur"
          }
        ]
      }
    };
  },

  mounted() {
     this.publicGetExperimentList(); //获取实验列表
    this.getTchClassArr();
    this.getCoursesArr(this.pageData);
  },
  methods: {
    // 获取所有实验
     async publicGetExperimentList() {
      this.ExperimentList = await homeApi.publicGetExperimentList();
    },
    //教师负责班级信息
    async getTchClassArr() {
      this.classList = await homeApi.GetTchClass();
    },
    // 获取教师分页数据
    async getCoursesArr(pageData) {
      this.listObj = await homeApi.GetCoursesList(pageData);
      this.loading = false;
    },
    //时间段处理
    getTime(value, str) {
      if (str == "daterange") {
        this.pageData["start_date"] = value[0];
        this.pageData["end_date"] = value[1];
      } else if (str == "training") {
        this.editItem.StartTime = value[0];
        this.editItem.EndTime = value[1];
      } else {
        this.editItem.TestStartTime = value[0];
        this.editItem.TestTime = value[1];
      }
    },
    //添加
    addItemFn(name) {
      this.$refs["editItem"].resetFields();
      this.showModal = true;
      this.editApi = "AddCourses";
      this.editItem = {
        Counts: 0,
        ResultsPer: 100,
        ExpPer: 0
      };
      this.training = [];
      this.assess = [];
      this.daterange = "";
      this.pageData.page = 1;
      this.pageData["start_date"] = "";
      this.pageData["end_date"] = "";
      this.options1 = {
        disabledDate(date) {
          return date && date.valueOf() < Date.now() - 86400000;
        }
      };
      this.options2 = {
        disabledDate(date) {
          return date && date.valueOf() < Date.now() - 86400000;
        }
      };
    },
    //编辑
    editItemFn(row) {
      this.$refs["editItem"].resetFields();
      this.editItem = JSON.parse(JSON.stringify(row));
      this.training = [row.StartTime, row.EndTime];
      this.assess = [row.TestStartTime, row.TestTime];
      this.showModal = true;
      this.options1 = {
        disabledDate(date) {
          return date < new Date(row.StartTime) - 86400000;
        }
      };
      this.options2 = {
        disabledDate(date) {
          return date < new Date(row.TestStartTime) - 86400000;
        }
      };
      this.editApi = "AmendCourses";
    },
    // 确认编辑
    sureEdit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          if (this.training.length > 0 && this.assess.length > 0) {
            homeApi[this.editApi](this.editItem).then(res => {
              if (res.success) {
                this.getCoursesArr(this.pageData);
                this.showModal = false;
                this.$Message.success({
                  content: res.msg,
                  duration: 3
                });
              } else {
                this.$Message.error({
                  content: res.msg,
                  duration: 3
                });
              }
            });
          } else {
            this.$Message.error({
              content: "练习时间或考核时间不能为空",
              duration: 3
            });
          }
        } else {
          this.$Message.error({
            content: "请把数据填写完整",
            duration: 3
          });
        }
      });
    },
    //删除
    delItemFn(row) {
      this.$Modal.confirm({
        title: "删除课程",
        content: "确认删除" + row.CourseName,
        onOk: () => {
          homeApi.delCourses({ CourseId: row.CourseId }).then(res => {
            if (res.success) {
              this.pageData.page = 1;
              this.getCoursesArr(this.pageData);
              this.$Message.success({
                content: res.msg,
                duration: 3
              });
            } else {
              this.$Message.error({
                content: res.msg,
                duration: 3
              });
            }
          });
        }
      });
    },
    searchByTime(type) {
      if (type == "refresh") {
        this.daterange = [];
        this.pageData["start_date"] = "";
        this.pageData["end_date"] = "";
      } else {
        this.pageData["start_date"] = this.pageData["start_date"]
          ? this.pageData["start_date"]
          : "";
        this.pageData["end_date"] = this.pageData["end_date"]
          ? this.pageData["end_date"]
          : "";
      }
      this.pageData.page = 1;
      this.getCoursesArr(this.pageData);
    },
    //分页
    changePage(page) {
      this.pageData.page = page;
      // this.pageData["start_date"] = "";
      // this.pageData["end_date"] = "";
      this.getCoursesArr(this.pageData);
    },
    changeResultsPer(val) {
      this.editItem.ExpPer = 100 - val;
    },
    // 实验报告成绩占比
    changeExpPer(val) {
      this.editItem.ResultsPer = 100 - val;
    }
  }
};
</script>

<style scoped>
</style>